export const QR_PROFILE_SOURCE = 'qr_profile';
export const QR_BOOKING_SOURCE = 'qr_booking';

export function isQrProfileSource(source: string | null | undefined): boolean {
  return source === QR_PROFILE_SOURCE;
}

export function isQrBookingSource(source: string | null | undefined): boolean {
  return source === QR_BOOKING_SOURCE;
}
